import Layout from "@/components/Layout";
import SEO from "@/components/SEO";
import { Eyebrow, SectionLabel } from "@/components/Eyebrow";

const SECTIONS = [
  { h: "Volume reality", b: "Harvard typically admits 12-16 transfers from a pool of 2,000+. This is not a numbers game. We approach Harvard transfer engagements with restraint and a long view." },
  { h: "Eligibility", b: "Fall entry only. Must have completed at least one continuous academic year (full-time), but not more than two. The window is narrow by design." },
  { h: "Testing", b: "SAT/ACT required, with rare exceptions. Plan for a full prep cycle. Send all scores; do not super-score selectively." },
  { h: "The academic-necessity thesis", b: "Harvard transfer admission is not about academic performance. It is about academic necessity. The student must demonstrate they have exhausted their current academic environment. This is fundamentally different from Florida transfer logic — do not mix the two." },
  { h: "What we build for elite applicants", b: "A Harvard Exceptional Dossier: liberal-arts rigor, one-to-two-year eligibility window managed precisely, faculty recommendations from professors who can speak in depth to your work, testing readiness, and a hard academic-necessity thesis. Not a 'feeder narrative.'" },
];

export default function PlaybookHarvard() {
  return (
    <Layout>
      <SEO
        title="Harvard Transfer Playbook — The Academic-Necessity Thesis"
        description="Harvard admits 12-16 transfers a year. Fall entry only. SAT/ACT required. The academic-necessity thesis is not academic performance. What actually gets in."
        canonical="/playbooks/harvard"
        keywords="Harvard transfer, Harvard College transfer admissions, academic necessity thesis, community college to Harvard, low-volume transfer"
      />
      <section className="border-b border-stone/30 bg-bone" data-testid="playbook-harvard-page">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 pt-20 lg:pt-28 pb-16">
          <div className="mb-6 border-l-2 border-brass pl-4 py-2 text-xs text-ink-soft" data-testid="playbook-harvard-fl-callout">
            <div className="text-[10px] uppercase tracking-[0.22em] text-brass font-semibold">Florida Specialization Playbook</div>
            <div className="mt-1">Part of the Beyond Valencia Florida transfer engine. For Ivy / elite pathways today, our partner is <a href="/partners/ivy-league-consulting" className="text-ivy hover:text-brass underline">Ivy League Consulting</a>.</div>
          </div>
          <Eyebrow>Florida Specialization Playbook · Harvard Transfer</Eyebrow>
          <h1 className="font-serif font-medium text-4xl sm:text-5xl lg:text-[4.75rem] text-ink leading-[1.04] tracking-tightest mt-5">
            Harvard Transfer<br /><span className="italic text-ivy">Admissions.</span>
          </h1>
          <p className="mt-6 text-ink-soft text-base sm:text-lg max-w-2xl leading-relaxed">
            A restrained, low-volume engagement. We do not sell false hope. We engineer the small number of cases where the academic-necessity case is real.
          </p>
        </div>
      </section>

      <article className="max-w-3xl mx-auto px-5 sm:px-8 py-20 lg:py-24 space-y-12">
        {SECTIONS.map((s, i) => (
          <div key={s.h} className="border-l-2 border-brass pl-5">
            <SectionLabel index={String(i + 1).padStart(2, "0")} label={s.h} />
            <p className="mt-4 text-ink-soft leading-relaxed">{s.b}</p>
          </div>
        ))}
      </article>

      <section className="bg-ivy text-bone py-20 text-center">
        <p className="font-serif font-medium text-2xl sm:text-3xl tracking-tight px-5">Discuss eligibility.</p>
        <a href="/transfer-audit" className="inline-block mt-8 bg-brass hover:bg-brass-soft text-ink uppercase tracking-[0.18em] text-xs font-semibold py-4 px-8 transition-colors">Schedule Audit — $249</a>
      </section>
    </Layout>
  );
}
